import React from "react";
import Qn1 from "./Questions/qn1";
import Qn2 from "./Questions/qn2";
import Qn3 from "./Questions/qn3";
import Qn4 from "./Questions/qn4";
import Qn5 from "./Questions/qn5";
import Qn6 from "./Questions/qn6";
import Qn7 from "./Questions/qn7";
import Qn8 from "./Questions/qn8";
import Qn9 from "./Questions/qn9";
import Qn10 from "./Questions/qn10";
import Qn11 from "./Questions/qn11";
import Qn12 from "./Questions/qn12";
import Qn13 from "./Questions/qn13";
import Qn14 from "./Questions/qn14";

const Questions = () => {
  return (
    <div>
      <Qn1 />
      <Qn2 />
      <Qn3 />
      <Qn4 />
      <Qn5 />
      <Qn6 />
      <Qn7 />
      <Qn8 />
      <Qn9 />
      <Qn10 />
      <Qn11 />
      <Qn12 />
      <Qn13 />
      <Qn14 />
    </div>
  );
};
export default Questions;
